import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, CardBody, Table, Spinner, Row, Col } from "reactstrap";
import { getCoordinatorDetailsApi } from "../../api/apiUrlConst";
import { toast } from "react-toastify";

const PerformanceDetails: React.FC = () => {
  const { name } = useParams();
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (name) loadDetails();
  }, [name]);

  const loadDetails = async () => {
    try {
      const result = await getCoordinatorDetailsApi(name!);
      setData(result);
    } catch (error:any) {
      toast.error("Error loading details:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Spinner />;

  return (
    <>
  {/* ===== PERFORMANCE HEADER CARD ===== */}
  <div
    className="mb-4 p-4"
    style={{
      background: "linear-gradient(90deg,#374151, #093d92)",
      borderRadius: "15px",
      color: "#fff",
    }}
  >
    <h3 className="fw-bold mb-1">
      {data.coordinator} - Performance Overview
    </h3>
    <small>Detailed analytics and assigned enquiries</small>
  </div>

  {/* ===== STAT CARDS ===== */}
  <Row className="mb-4 g-3">
    <Col md={6}>
      <Card
        className="border-0 shadow-sm"
        style={{ borderRadius: "15px" }}
      >
        <CardBody className="d-flex justify-content-between align-items-center">
          <div>
            <div className="text-muted">Total Enquiries</div>
            <h3 className="fw-bold mb-0">
              {data.totalEnquiries}
            </h3>
          </div>
          <div
            style={{
              background: "#e7f5ff",
              padding: "15px",
              borderRadius: "50%",
              fontSize: "22px",
            }}
          >
            📩
          </div>
        </CardBody>
      </Card>
    </Col>

    <Col md={6}>
      <Card
        className="border-0 shadow-sm"
        style={{ borderRadius: "15px" }}
      >
        <CardBody className="d-flex justify-content-between align-items-center">
          <div>
            <div className="text-muted">Total Revenue</div>
            <h3 className="fw-bold mb-0 text-success">
              ₹ {data.revenue.toLocaleString()}
            </h3>
          </div>
          <div
            style={{
              background: "#e6fcf5",
              padding: "15px",
              borderRadius: "50%",
              fontSize: "22px",
            }}
          >
            💰
          </div>
        </CardBody>
      </Card>
    </Col>
  </Row>

  {/* ===== ENQUIRIES TABLE ===== */}
  <Card
    className="border-0 shadow-sm"
    style={{ borderRadius: "15px" }}
  >
    <CardBody>
      <h5 className="fw-semibold mb-3">
        Assigned Enquiries
      </h5>

      <Table
        responsive
        hover
        className="align-middle"
        style={{
          borderCollapse: "separate",
          borderSpacing: "0 8px",
        }}
      >
        <thead>
          <tr style={{ background: "#f4f6fb" }}>
            <th>EID</th>
            <th>Name</th>
            <th>Course</th>
            <th>Status</th>
            <th>Submitted</th>
          </tr>
        </thead>

        <tbody>
          {data.enquiries.map((e: any, index: number) => (
            <tr
              key={index}
              style={{
                background: "#fff",
                boxShadow:
                  "0 2px 10px rgba(0,0,0,0.03)",
                borderRadius: "10px",
              }}
            >
              <td className="fw-semibold">
                {e.eid}
              </td>

              <td>{e.name}</td>

              <td>{e.courseName}</td>

              <td>
                <span
                  style={{
                    padding: "5px 12px",
                    borderRadius: "20px",
                    fontSize: "12px",
                    fontWeight: 500,
                    background:
                      e.status === "Joined"
                        ? "#a4f5af"
                        : e.status === "Assigned"
                        ? "#fff3bf"
                        : "#bcddf5",
                    color:
                      e.status === "Joined"
                        ? "#2b8a3e"
                        : e.status === "Assigned"
                        ? "#e67700"
                        : "#0088ff",
                  }}
                >
                  {e.status}
                </span>
              </td>

              <td>
                {new Date(
                  e.submittedAt
                ).toLocaleDateString()}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </CardBody>
  </Card>
</>
  );
};

export default PerformanceDetails;